const optionsSearchPay = [
    {
        label: 'สัญญา',
        value: 1,
    },
    {
        label: 'เลขบัตรประชาชน',
        value: 2,
    },
    {
        label: 'ชื่อ-นามสกุล',
        value: 3,
    },
    {
        label: 'ทะเบียนรถ',
        value: 4,
    },
]

export { optionsSearchPay };